import { Link } from "react-router-dom";
import { MessageCircle } from "lucide-react";

// Configuración de WhatsApp - Cambiar aquí el número si es necesario
const WHATSAPP_NUMBER = "593997541192";
const WHATSAPP_MESSAGE = "Hola, quiero suscribirme a ContaFLIX PRO. ¿Me ayudas a elegir el plan? Soy (emprendedor/contador) y mi duda es: ";

const Footer = () => {
  const handleWhatsAppClick = () => {
    const url = `https://api.whatsapp.com/send?phone=${WHATSAPP_NUMBER}&text=${encodeURIComponent(WHATSAPP_MESSAGE)}`;
    window.open(url, '_blank', 'noopener,noreferrer');
  };

  return (
    <footer className="bg-black border-t border-white/5 py-12">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8 mb-8">
          <div>
            <Link to="/">
              <img src="/logo-v4.png" alt="CONTAFLIX" className="h-8 w-auto object-contain mb-4" />
            </Link>
            <p className="text-white/60 text-sm">
              Aprende Contabilidad y Tributos con claridad, orden y cero estrés.
            </p>
          </div>

          <div>
            <h4 className="text-white font-semibold mb-4">Plataforma</h4>
            <ul className="space-y-2 text-sm">
              <li>
                <Link to="/cursos" className="text-white/60 hover:text-white transition-colors">
                  Cursos
                </Link>
              </li>
              <li>
                <Link to="/contaflix-pro" className="text-white/60 hover:text-white transition-colors">
                  ContaFLIX PRO
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="text-white font-semibold mb-4">Legal</h4>
            <ul className="space-y-2 text-sm">
              <li>
                <a href="#" className="text-white/60 hover:text-white transition-colors">
                  Políticas de privacidad
                </a>
              </li>
              <li>
                <a href="#" className="text-white/60 hover:text-white transition-colors">
                  Términos y condiciones
                </a>
              </li>
              <li>
                <a href="#" className="text-white/60 hover:text-white transition-colors">
                  Aviso de cookies
                </a>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="text-white font-semibold mb-4">Soporte</h4>
            <ul className="space-y-2 text-sm">
              <li>
                <a href="#" className="text-white/60 hover:text-white transition-colors">
                  Contacto
                </a>
              </li>
              <li>
                <a href="#" className="text-white/60 hover:text-white transition-colors">
                  Centro de ayuda
                </a>
              </li>
              <li>
                <button 
                  onClick={handleWhatsAppClick}
                  aria-label="Contactar por WhatsApp"
                  className="inline-flex items-center gap-2 text-white bg-white/5 border border-white/20 hover:border-[#E50914] hover:text-[#E50914] px-3 py-1.5 rounded-md transition-all duration-300 mt-2 cursor-pointer"
                  data-testid="whatsapp-btn"
                >
                  <MessageCircle className="w-4 h-4" />
                  WhatsApp
                </button>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-white/5 pt-8 text-center text-white/40 text-sm">
          <p>© {new Date().getFullYear()} CONTAFLIX. Todos los derechos reservados.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
